import React from 'react';

const TextInput = ({ 
  id, 
  name, 
  label, 
  value, 
  defaultValue,
  onChange, 
  placeholder, 
  type = 'text', 
  required = false,
  maxLength,
  ...props 
}) => {
  const handleChange = (e) => {
    if (onChange) {
      // Always pass the full event object to maintain compatibility
      onChange(e);
    }
  };

  return (
    <div className="text-input-group">
      {label && (
        <label htmlFor={id || name} className="text-input-label">
          {label}
        </label>
      )}
      <input
        id={id || name}
        name={name}
        type={type}
        value={value}
        defaultValue={defaultValue}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        maxLength={maxLength}
        className="text-input"
        {...props}
      />
    </div>
  );
};

export default TextInput;
